import { createContext, useContext, useEffect, useState } from "react";
import { api } from "./api";
import { portalPathForRole } from "./permissions";

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(() => {
    const raw = localStorage.getItem("ts_user");
    return raw ? JSON.parse(raw) : null;
  });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem("ts_token");
    if (!token) {
      setLoading(false);
      return;
    }
    api.get("/auth/me").then((r) => {
      setUser(r.data);
      localStorage.setItem("ts_user", JSON.stringify(r.data));
    }).catch(() => {
      localStorage.removeItem("ts_token");
      localStorage.removeItem("ts_user");
      setUser(null);
    }).finally(() => setLoading(false));
  }, []);

  const login = async (email, password) => {
    const r = await api.post("/auth/login", { email, password });
    localStorage.setItem("ts_token", r.data.token);
    localStorage.setItem("ts_user", JSON.stringify(r.data.user));
    setUser(r.data.user);
    return r.data.user;
  };

  const logout = () => {
    localStorage.removeItem("ts_token");
    localStorage.removeItem("ts_user");
    setUser(null);
  };

  return (
    <AuthCtx.Provider value={{ user, loading, login, logout }}>
      {children}
    </AuthCtx.Provider>
  );
}

export const useAuth = () => useContext(AuthCtx);

// Role routing: which portal to send user to after login
export function rolePortal(role) {
  return portalPathForRole(role);
}
